import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { Setting } from '@app-state';
import { ClientErrorCodes, enumMapper, globalStateFilter, TRIGGER_TYPE_FILTER, TriggerType, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { TriggersGridService } from '@services';
import { BehaviorSubject } from 'rxjs';
import { finalize, takeUntil, } from 'rxjs/operators';
var ɵ0 = urlStateHandler;
var TriggersPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TriggersPageComponent, _super);
    function TriggersPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.statusList = globalStateFilter();
        _this.typeList = enumMapper(TriggerType, {
            resourceKey: 'trigger_type',
            filterValueMap: TRIGGER_TYPE_FILTER,
        });
        _this.hasQueuesViewPermission$ = _this._appState.user.permissions
            .isGranted('Queues.View');
        _this.hasRobotsViewPermission$ = _this._appState.user.permissions
            .isGranted('Robots.View');
        _this._triggersService = _this._service;
        return _this;
    }
    Object.defineProperty(TriggersPageComponent.prototype, "currentTimezone", {
        get: function () {
            return this._appState.settings.get(Setting.timezone);
        },
        enumerable: true,
        configurable: true
    });
    TriggersPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._appState.language.change$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function () { return _this._refresh$.next(); });
    };
    Object.defineProperty(TriggersPageComponent.prototype, "isEverySelectedEntryDisabled", {
        get: function () {
            return !this._grid.selectionManager.selected.every(function (e) { return !e.enabled; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TriggersPageComponent.prototype, "isEverySelectedEntryEnabled", {
        get: function () {
            return !this._grid.selectionManager.selected.every(function (e) { return e.enabled; });
        },
        enumerable: true,
        configurable: true
    });
    TriggersPageComponent.prototype.setState = function (enabled, triggerId) {
        var _this = this;
        var triggerIds = triggerId ?
            [triggerId] :
            this._grid.selectionManager.selected.map(function (e) { return e.id; });
        if (!triggerIds.length) {
            return;
        }
        this.loading$.next(true);
        this._triggersService.setEnabled(triggerIds, enabled)
            .pipe(finalize(function () {
            _this._refresh$.next();
            _this.loading$.next(false);
        }))
            .subscribe(function (res) {
            if (enabled && !res.value) {
                _this._snack.error(_this._translate.instant('triggers_not_all_triggers_enabled_error') + " (#" + ClientErrorCodes.TriggersNotAllEnabled + ")");
            }
        });
    };
    return TriggersPageComponent;
}(ODataGridComponent));
export { TriggersPageComponent };
export { ɵ0 };
